import React from 'react';
import { Typography, Box, Divider, useMediaQuery, useTheme } from '@mui/material';

const Title = ({ text }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        width: '100%',
        textAlign: 'center',
        padding: isMobile ? '16px 0' : '24px 0',
      }}
    >
      <Typography
        variant={isMobile ? 'h5' : 'h4'}
        sx={{
          fontWeight: 400,
          letterSpacing: 1.2,
          color: theme.palette.text.primary,
          marginBottom: 5,
        }}
      >
        {text}
      </Typography>
      <Divider
        sx={{
            marginTop: 1,
            borderBottom: '1px solid rgba(255, 255, 255, 0.2)', // ✅ Exact style without extra thickness
            opacity: 1, // ✅ Ensures clarity
        }}
        />


    </Box>
  );
};

export default Title;
